export const UPDATE_USER_PROJECT_BOARD_DATA_REQUEST =
  "UPDATE_USER_PROJECT_BOARD_DATA_REQUEST";
export const UPDATE_USER_PROJECT_BOARD_DATA_SUCCESS =
  "UPDATE_USER_PROJECT_BOARD_DATA_SUCCESS";
export const UPDATE_USER_PROJECT_BOARD_DATA_FAILURE =
  "UPDATE_USER_PROJECT_BOARD_DATA_FAILURE";
